import { useState, useEffect, useMemo } from 'react';

export default (uniqueFacetKey, checked, disabled) => {
    const [inpChecked, setInpChecked] = useState(null);

    useEffect(() => {
        if(typeof inpChecked === 'boolean' && !disabled){
            setInpChecked(null);
        }
    }, [`${uniqueFacetKey}-${checked}`])

    const derivedCheck = typeof inpChecked === 'boolean' ? inpChecked : checked;

    return useMemo(() => disabled ? null : ({
        derivedCheck,
        setInpChecked
    }), [derivedCheck, disabled])
}